module.exports = __webpack_public_path__ + "img/logo.c173833c.png";